export default __webpack_public_path__ + "static/media/horn.edef87b4.svg";